import { EventComplete } from "./EventComplete";

export default EventComplete;